export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40044a7991f9e43a5ededa15e984a96fd3aebb2f57&name=revalidateCommunity!'